$(document).ready(function () {
  $('.banner-list').slick({
    dots: true,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1
  });


  $('.announcement-ctnt').slick({
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.custom_featured_coll').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


if ($(window).width() < 767){ 
$('.icon-with-text .icon-list').slick({
  dots: true,
  arrows: false,
  infinite: false,
  autoplay:true,
  autoplaySpeed:2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
}
  


  $('.custom-featured-pro .custom-pro-thumbs').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1481,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

 $('.custom-main-pro .custom-pro-thumbs').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.customer-reviews .reviews-list').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1
});

$('.landing-reviews .reviews-list').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000
});

  $('.landing-featured-pro .custom-pro-thumbs').slick({
  dots: false,
  arrows: true,
  vertical: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$(document).on('click','.quantity-selector',function(){
  var selected_qty = $(this).find('.quantity-selector__input').val();
  $('#quantity').val(selected_qty);
});

});

Shopify.fetchCart = async () => {
  return fetch(Shopify.routes.root + 'cart.js')
    .then(r => r.json())
  }

  document.addEventListener("Lensify:addToCart", async () => {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    const cartData = await Shopify.fetchCart()

    const cartHeader = document.querySelector("a.custom_header_cart")
    cartHeader.querySelector('.cart-text').innerHTML = `<span class="cart-count-text">Cart</span>(${cartData.items.length})`
    document.dispatchEvent(new CustomEvent("cart:refresh"))

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

    setTimeout(() => {
      document.querySelector(".custom_header_cart").click()
    }, 10)
})
